
export { FavoriteVehicleTypeDTO } from "./main39.js"